import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "62",
  height: "62",
  fill: "none",
  viewBox: "0 0 62 62"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "30.891",
      cy: "31",
      r: "30.5",
      fill: "#FDBC04",
      "fill-opacity": ".2"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#FDBC04",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M42.527 31.351c-.508 6.16-5.708 11-12 11a12 12 0 0 1-12-12c0-6.291 4.84-11.491 11-12"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#FDBC04",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M30.527 23.351v7h7"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#FDBC04",
      d: "M34.527 20.351a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m4.5 3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m3 4.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
    }, null, -1)
  ]))]))
}
export default { render: render }